import React from 'react';
import { Route } from "react-router-dom";
import EmailValidator from './email_validator.view';


const EmailValidatorRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} component={EmailValidator} />
  </div>
);

export default EmailValidatorRouter;
